module.exports = __webpack_public_path__ + "media/images/youTube-07d5ebd4.png";